import { useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import { addComment } from '../../../services/api.helpers';
import { fetchTask } from '~actions/transferActions';
import SendIcon from '~images/send-comment.svg';
import { grey, primaryColor, smallGap } from '~theme';

const CommentField = ({ orderId }) => {
  const [message, setMessage] = useState('');

  const dispatch = useDispatch();

  const handleSubmit = event => {
    event.preventDefault();
    if (message.length > 0) {
      // HACK
      addComment(orderId, message).then(
        setTimeout(() => dispatch(fetchTask(orderId)), 1000)
      );
      setMessage('');
    }
  };

  return (
    <>
      <CommentForm onSubmit={handleSubmit}>
        <CommentInput
          placeholder="Kirjoita tähän..."
          value={message}
          onChange={e => setMessage(e.target.value)}
        />
        <SendButton>
          <Icon src={SendIcon} alt="Lähetä" />
        </SendButton>
      </CommentForm>
    </>
  );
};

const CommentInput = styled.input`
  width: 100%;
  height: auto;

  padding: 8px 10px;
  margin-right: 12px;

  border-radius: 3px;
  border: 1px solid ${grey};
  outline: 0;

  font-size: 16px;
  font-weight: 400;

  &:focus {
    border-color: ${primaryColor};
  }
`;

const Icon = styled.img`
  width: 40px;
  margin-top: ${smallGap};
`;

const CommentForm = styled.form`
  display: flex;
  flex-direction: row;
  height: 40px;
`;

const SendButton = styled.button`
  background-color: transparent;
  border: 0;
  outline: 0;
`;

export default CommentField;
